import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    // 首页
    {
        path: '/',
        name: 'Home',
        component: () =>
            import ('../views/Home.vue')
    },
    // 云论坛
    {
        path: '/forum',
        name: 'Forum',
        component: () =>
            import ('../views/Forum/index.vue')
    },
    // 云论坛详情
    {
        path: '/forum/:id',
        name: 'ForumDetail',
        component: () =>
            import ('../views/Forum/_idnew.vue')
    },
    // 云论坛详情新
    {
        path: '/cloud/:id',
        name: 'ForumDetailNew',
        component: () =>
            import ('../views/Forum/_idnew.vue')
    },
    // 企业详情
    {
        path: '/company',
        name: 'CompanyDetail',
        component: () =>
            import ('../views/Company/index.vue')
    },
    // 嘉宾列表
    {
        path: '/speakers',
        name: 'Speakers',
        component: () =>
            import ('../views/Speakers/index.vue')
    },
    // 嘉宾详情
    {
        path: '/speakers/:id',
        name: 'SpeakersDetail',
        component: () =>
            import ('../views/Speakers/_id.vue')
    },
    // 频道详情页
    {
        path: '/channel/:id',
        name: 'Channel',
        component: () =>
            import ('../views/Channel/index.vue')
    },
    // 文章详情页
    {
        // path: '/detail/id=1',
        path: '/detail/:id',
        name: 'detail',
        component: () =>
            import ('../views/Detail/index.vue')
    },
    /// reportInstructions举报须知
    {
        path: '/reportInstructions/:id',
        name: 'ReportInstructions',
        component: () =>
            import ('../views/ReportInstructions/index.vue')
    },
    {
        path: '/reportInstructions/:id/:subId',
        name: 'ReportInstructions',
        component: () =>
            import ('../views/ReportInstructions/index.vue')
    },
    // reportDetails 举报详情的地址
    {
        path: '/reportDetails/:id',
        name: 'ReportDetails',
        component: () =>
            import ('../views/ReportDetails/index.vue')
    },
    {
        path: '/reportDetails/:id/:subId',
        name: 'ReportDetails',
        component: () =>
            import ('../views/ReportDetails/index.vue')
    },
    // 新闻详情页
    {
        path: '/news/:id/:from?',
        name: 'News',
        component: () =>
            import ('../views/News.vue')
    },
    // 视频详情页
    {
        path: '/video/:id',
        name: 'Video',
        component: () =>
            import ('../views/Video.vue')
    },
    // 直播详情页
    {
        path: '/live/:id',
        name: 'Live',
        component: () =>
            import ('../views/Live.vue')
    },
    // 图集详情页
    {
        path: '/atlas/:id',
        name: 'Atlas',
        component: () =>
            import ('../views/Atlas.vue')
    },
    // 资讯中心-常见问题
    {
        path: '/faq',
        name: 'FAQ',
        component: () =>
            import ('../views/FAQ.vue')
    },
    // 专题页面
    {
        path: '/subject/:id',
        name: 'Subject',
        component: () =>
            import ('../views/Subject.vue')
    },
    // 专题页面
    {
        path: '/latest/:id',
        name: 'Latest',
        component: () =>
            import ('../views/Channel/latest.vue')
    },
    // 精彩回顾
    {
        path: '/views/:id',
        name: 'Views',
        component: () =>
            import ('../views/Channel/Views.vue')
    },
    // 登录注册
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import ('../views/NewLogin.vue')
    },
    // 注册
    {
        path: '/register',
        name: 'Register',
        component: () =>
            import ('../views/Register.vue')
    },
    // 其他类
    {
        path: '/otherReports',
        name: 'OtherReports',
        component: () =>
            import ('../views/OtherReports.vue')
    },
    // 个人中心
    {
        path: '/personal',
        name: 'Personal',
        component: () =>
            import ('@/views/PersonalCenter/Personal.vue')
    },
    // 监督员
    {
        path: '/authentication',
        name: 'Authentication',
        component: () =>
            import ('@/views/PersonalCenter/Authentication.vue')
    },
    // 观展足迹
    {
        path: '/footprint',
        name: 'Footprint',
        component: () =>
            import ('../views/Footprint.vue')
    },
    // 隐私政策
    {
        path: '/privacy',
        name: 'Privacy',
        component: () =>
            import ('../views/Privacy.vue')
    },
    // 用户协议
    {
        path: '/agreement',
        name: 'Agreement',
        component: () =>
            import ('../views/Agreement.vue')
    },
    // 大会声明
    {
        path: '/declare',
        name: 'Declare',
        component: () =>
            import ('../views/Declare.vue')
    },
    // 知识产权
    {
        path: '/rightProtection',
        name: 'RightProtection',
        component: () =>
            import ('../views/RightProtection.vue')
    },
    // 侵权类
    {
        path: '/reportInstructionsOther',
        name: 'ReportInstructionsOther',
        component: () =>
            import ('../views/ReportInstructionsOther.vue')
    },
    // 搜索
    {
        path: '/search',
        name: 'Search',
        component: () =>
            import ('../views/Search.vue')
    },
    // 知识产权
    {
        path: '/404',
        name: '404',
        component: () =>
            import ('../views/404.vue')
    },

    // 不存在的路由，去到首页
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.NODE_ENV === 'production' ? '/wap/' : '/',
    routes
})

export default router
